import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] text-white pt-20 pb-10 border-t border-gray-900 font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Top Section: Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">

          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <h2 className="text-2xl font-display font-bold tracking-tight text-white">
                Hawkins & Brooks <span className="text-[#c8a45e]">Luxury Properties</span>
              </h2>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Your premier partner for exclusive luxury real estate in Dubai. We specialize in high-end residential and commercial properties, offering bespoke services for discerning clients.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#c8a45e] hover:text-white transition-all duration-300">
                <FaFacebookF size={14} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#c8a45e] hover:text-white transition-all duration-300">
                <FaTwitter size={14} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#c8a45e] hover:text-white transition-all duration-300">
                <FaInstagram size={14} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#c8a45e] hover:text-white transition-all duration-300">
                <FaLinkedinIn size={14} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 relative inline-block after:content-[''] after:absolute after:-bottom-2 after:left-0 after:w-12 after:h-1 after:bg-[#c8a45e]">
              Quick Links
            </h3>
            <ul className="space-y-4 text-sm text-gray-400">
              <li>
                <Link to="/" className="hover:text-[#c8a45e] transition-colors flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#c8a45e] opacity-0 hover:opacity-100 transition-opacity"></span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/properties/residential" className="hover:text-[#c8a45e] transition-colors flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#c8a45e] opacity-0 hover:opacity-100 transition-opacity"></span>
                  Properties
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#c8a45e] transition-colors flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#c8a45e] opacity-0 hover:opacity-100 transition-opacity"></span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#c8a45e] transition-colors flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#c8a45e] opacity-0 hover:opacity-100 transition-opacity"></span>
                  Contact
                </Link>
              </li>
            </ul>
          </div>



          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 relative inline-block after:content-[''] after:absolute after:-bottom-2 after:left-0 after:w-12 after:h-1 after:bg-[#c8a45e]">
              Get in Touch
            </h3>
            <ul className="space-y-6 text-sm text-gray-400">
              <li className="flex items-start gap-4">
                <div className="w-8 h-8 rounded-full bg-[#c8a45e]/10 flex items-center justify-center text-[#c8a45e] shrink-0">
                  <FaMapMarkerAlt />
                </div>
                <span>
                  Hawkins & Brooks Office Suite# 18,<br />
                  18th Floor, Wave One Tower,<br />
                  Noida, Uttar Pradesh 201301
                </span>
              </li>
              <li className="flex items-center gap-4">
                <div className="w-8 h-8 rounded-full bg-[#c8a45e]/10 flex items-center justify-center text-[#c8a45e] shrink-0">
                  <FaPhoneAlt />
                </div>
                <a href="tel:+918793764853" className="hover:text-[#c8a45e] transition-colors">
                  +91 87937 64853
                </a>
              </li>
              <li className="flex items-center gap-4">
                <div className="w-8 h-8 rounded-full bg-[#c8a45e]/10 flex items-center justify-center text-[#c8a45e] shrink-0">
                  <FaEnvelope />
                </div>
                <a href="mailto:info@dubaipropertybazaar18.com" className="hover:text-[#c8a45e] transition-colors break-all">
                  info@dubaipropertybazaar18.com
                </a>
              </li>
            </ul>
          </div>

        </div>



        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} <span className="text-white font-bold">Hawkins & Brooks Luxury Properties</span>. All Rights Reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <Link to="#" className="hover:text-[#c8a45e] transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-[#c8a45e] transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-[#c8a45e] transition-colors">Cookie Policy</Link>
          </div>
        </div>

      </div>
    </footer>
  );
}
